import { axiosInstance } from '../../helpers'

export interface VendorSubAssignRule {
    id: number
    apartment: number
    apartment_name: string
    service: number
    service_name: string
    sub_vendor: number
    sub_vendor_user_id: number
    sub_vendor_name: string | null
}

export interface AssignSlicePayload {
    apartment_id: number
    service_id: number
    user_id: number
    save_rule?: boolean
}

export interface AssignSliceResponse {
    assigned_count: number
    workorders: unknown[]
    rule?: VendorSubAssignRule
}

const vendorParams = { all_jobsites: true }

export const fetchVendorSubAssignRules = async (): Promise<
    VendorSubAssignRule[]
> => {
    const res = await axiosInstance.get<VendorSubAssignRule[]>(
        'workorder/workorder-sub-assign-rule/',
        { params: vendorParams },
    )
    return Array.isArray(res.data) ? res.data : []
}

export const createVendorSubAssignRule = async (body: {
    apartment: number
    service: number
    sub_vendor: number
}): Promise<VendorSubAssignRule> => {
    const res = await axiosInstance.post<VendorSubAssignRule>(
        'workorder/workorder-sub-assign-rule/',
        body,
        { params: vendorParams },
    )
    return res.data
}

export const deleteVendorSubAssignRule = async (id: number): Promise<void> => {
    await axiosInstance.delete(`workorder/workorder-sub-assign-rule/${id}/`, {
        params: vendorParams,
    })
}

export const assignSubSlice = async (
    payload: AssignSlicePayload,
): Promise<AssignSliceResponse> => {
    const res = await axiosInstance.post<AssignSliceResponse>(
        'workorder/workorder-sub-contract/assign-slice/',
        payload,
        { params: vendorParams },
    )
    return res.data
}

export const fetchEnabledServicesAtApartment = async (
    apartmentId: number,
): Promise<Array<{ id: number; name: string }>> => {
    const res = await axiosInstance.get<Array<{ id: number; name?: string }>>(
        'company/apartment_vendors/enabled_services/',
        { params: { apartment_id: apartmentId } },
    )
    const data = Array.isArray(res.data) ? res.data : []
    return data.map((s) => ({
        id: s.id,
        name: s.name ?? '',
    }))
}
